import './amident.css'
import './index.css'
import 'swiper/swiper-bundle.css';
import './calendar.css'

// TODO: switch to SVG+JS to reduce size
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bulma/css/bulma.css'

